import React from "react";
import PropTypes from "prop-types";

const Checkbox = ({ label, bindName, value, onChange }) => {
    return (
        <div className="pottsalat-form__row">
            <div className="pottsalat-form__checkbox">
                <label>
                    <input
                        type="checkbox"
                        name={bindName}
                        value={value}
                        onChange={onChange}
                        checked={value}
                    />
                    <div>{label}</div>
                </label>
            </div>
        </div>
    );
};

Checkbox.propTypes = {
    label: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    bindName: PropTypes.string,
    value: PropTypes.bool,
    onChange: PropTypes.func,
};

export default Checkbox;
